@if (field && !fieldEmpty) {
  <div class="filter-field" @parent [id]="field.id">
    <mat-expansion-panel [expanded]="field?.expanded">
      <mat-expansion-panel-header [class.pointer-events-none]="!expandable">
        <mat-panel-title class="field-title gap-x-3">
          <span class="display-name" translate>
            {{ field.translationKey }}
          </span>

          @if (expandable) {
            <svg-icon src="arrow-single" preserveAspectRatio="none" [stretch]="true"></svg-icon>
          }
        </mat-panel-title>
      </mat-expansion-panel-header>

      @if (isSearchFieldExist) {
        <app-data-search
          class="search-field"
          [data]="filteredOptions"
          [searchDefinitions]="searchDefinitions"
          [placeholderTranslationKey]="buildTranslationKey('search')"
          [shouldSetValueFromQueryParams]="false"
          [skipFocusing]="true"
          (search)="setFoundOptions($event)"
          (inputText)="setDefaultOptions($event)"
        ></app-data-search>
      }

      <div class="options-container">
        @if (!isSearchMode) {
          <div class="static-fields">
            @for (option of staticOptions; track optionTrackBy(i, option); let i = $index) {
              <ng-container *ngTemplateOutlet="optionTemplate; context: { option, i }"></ng-container>
            }
          </div>

          @if (collapsableOptions.length) {
            <div class="collapsable-fields overflow-hidden" @expandField>
              @for (option of collapsableOptions; track optionTrackBy($index, option)) {
                <ng-container *ngTemplateOutlet="optionTemplate; context: { option }"></ng-container>
              }
            </div>
          }
        } @else {
          @if (filteredOptionsToDisplay.length) {
            <div class="static-fields" @expandField>
              @for (option of filteredOptionsToDisplay; track optionTrackBy($index, option)) {
                <ng-container *ngTemplateOutlet="optionTemplate; context: { option }"></ng-container>
              }
            </div>
          }

          @if (!filteredOptionsToDisplay.length) {
            <div class="text-center text-base font-color-navy-70">
              <span>{{ buildTranslationKey('noResults') | translate }}</span>
            </div>
          }
        }
      </div>

      @if (isCollapsingSupported && !isSearchMode) {
        <app-new-button
          data-test-id="show-all-btn"
          class="mt-5 h-8"
          [type]="'secondary'"
          [size]="'stretch'"
          (click)="toggleShowMoreState()"
        >
          {{ buildTranslationKey(resolveShowAllButtonTranslationKey()) | translate }}
          @if (!isExpanded) {
            <span>&nbsp;({{ optionCount }})</span>
          }
        </app-new-button>
      }
    </mat-expansion-panel>
  </div>
}

<ng-template #optionTemplate let-option="option" let-index="i">
  @if (option?.isDisplayed) {
    <app-data-filter-option
      [attr.data-test-id]="option.id"
      [optionId]="option.id"
      [fieldId]="field.id"
      [filterInstanceId]="filterInstanceId"
    ></app-data-filter-option>
  }

  @if (isAddSeparationLine(index)) {
    <div class="h-px bg-navy-30"></div>
  }
</ng-template>
